export const billPaymentType = {
  'Billing::BankSlipPayment': 'Boleto',
  'Billing::WalletPayment': 'Carteira',
};
